<style lang="less" scoped>
.nodata {
  text-align: center;
  box-sizing: border-box;
  min-height: 100vh;
  img {
    width: 150px;
    margin-top: 55px;
  }
  p {
    text-align: center;
    margin-top: 30px;
    font-size: 18px;
  }
}
</style>
<template>
  <div>
    <div class="nodata">
      <img src="@/assets/images/nodata.png" />
      <p>{{ $t("main.content27") }}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>